import { inject, provide, reactive, ref } from 'vue';

export default {
  name: 'SponsorLogosComponent',
  props: {
    event: {
      type: Number,
      required: true,
    },
    displayPerRow: {
      type: Number,
      required: false,
      default: 5,
    },
    suppress: {
      type: Array,
      required: false,
      default: []
    },
    include: {
      type: Array,
      required: false,
      default: []
    },
  },
  setup(props) {

    let config = inject('config');
    config = { ...config, ...props.config };
    provide('config', config);

    const eventProvider = inject('eventProvider');

    const state = reactive({
      showNotification: ref(false),
      notification: ref(null),
      sponsors: ref([]),
      displayPerRow: ref(null),
    });

    const loadSponsors = async () => {
      state.showNotification = true;
      state.notification = 'Loading Sponsors...';
      let response = await eventProvider().loadEventSponsors(config, props.event);
      if (response.status === 'error' || response.success === false) {
        state.showNotification = true;
        state.notification = response.data.message || response.data.data.message || response.data.data;
      } else {
        if (props.suppress.length) {
          let sponsors = response.data.data;
          let filtered = sponsors.filter((sponsor) => {
            return !props.suppress.includes(sponsor.id);
          });
          state.sponsors = filtered;
        } else if (props.include.length) {
          let sponsors = response.data.data;
          let filtered = sponsors.filter((sponsor) => {
            return props.include.includes(sponsor.id);
          });
          state.sponsors = filtered;
        } else {
          state.sponsors = response.data.data;
        }
        state.showNotification = false;
        state.notification = null;
      }
    };

    const loadSponsorsPerRow = async () => {
      state.showNotification = true;
      state.notification = 'Loading Event Data...';
      let response = await eventProvider().loadEvent(props.event, config);
      if (response.status === 'success') {
        let event = response.data.data;
        if (event.layout.sponsors_per_row) {
          state.displayPerRow = event.layout.sponsors_per_row;
        } else {
          state.displayPerRow = props.displayPerRow;
        }
      }
      state.showNotification = false;
      state.notification = null;
    };

    const initialize = async () => {

      await loadSponsors();
      await loadSponsorsPerRow();

    };

    initialize();

    return { state };
  },
};
